import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IMapboxTilesetFieldsFragment = {
  id?: any | null
  mapboxTilesetId: string
  name: string
  createdAt?: any | null
  updatedAt?: any | null
  isProcessed: boolean
  status?: Types.TilesetProcessingStatus | null
  errors?: Array<string | null> | null
  mapboxData?: {
    id?: string | null
    name?: string | null
    type?: string | null
    center: Array<number>
    fileSize: any
  } | null
}

export type IGetMapboxTilesetsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetMapboxTilesetsQuery = {
  getMapboxTilesets?: Array<{
    id?: any | null
    mapboxTilesetId: string
    name: string
    createdAt?: any | null
    updatedAt?: any | null
    isProcessed: boolean
    status?: Types.TilesetProcessingStatus | null
    errors?: Array<string | null> | null
    mapboxData?: {
      id?: string | null
      name?: string | null
      type?: string | null
      center: Array<number>
      fileSize: any
    } | null
  } | null> | null
}

export type IListenTilesetsByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenTilesetsByProjectIdSubscription = {
  tileset?: {
    id?: any | null
    item?: {
      id?: any | null
      mapboxTilesetId: string
      name: string
      createdAt?: any | null
      updatedAt?: any | null
      isProcessed: boolean
      status?: Types.TilesetProcessingStatus | null
      errors?: Array<string | null> | null
      mapboxData?: {
        id?: string | null
        name?: string | null
        type?: string | null
        center: Array<number>
        fileSize: any
      } | null
    } | null
  } | null
}

export const MapboxTilesetFieldsFragmentDoc = gql`
  fragment MapboxTilesetFields on Tileset {
    id
    mapboxTilesetId
    name
    createdAt
    updatedAt
    isProcessed
    status
    errors
    mapboxData {
      id
      name
      type
      center
      fileSize
    }
  }
`
export const GetMapboxTilesetsDocument = gql`
  query GetMapboxTilesets($projectId: ObjectId!) {
    getMapboxTilesets(projectId: $projectId) {
      ...MapboxTilesetFields
    }
  }
  ${MapboxTilesetFieldsFragmentDoc}
`

/**
 * __useGetMapboxTilesetsQuery__
 *
 * To run a query within a React component, call `useGetMapboxTilesetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapboxTilesetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapboxTilesetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMapboxTilesetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetMapboxTilesetsQuery,
    IGetMapboxTilesetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetMapboxTilesetsQuery,
    IGetMapboxTilesetsQueryVariables
  >(GetMapboxTilesetsDocument, options)
}
export function useGetMapboxTilesetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetMapboxTilesetsQuery,
    IGetMapboxTilesetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetMapboxTilesetsQuery,
    IGetMapboxTilesetsQueryVariables
  >(GetMapboxTilesetsDocument, options)
}
export type GetMapboxTilesetsQueryHookResult = ReturnType<
  typeof useGetMapboxTilesetsQuery
>
export type GetMapboxTilesetsLazyQueryHookResult = ReturnType<
  typeof useGetMapboxTilesetsLazyQuery
>
export type GetMapboxTilesetsQueryResult = Apollo.QueryResult<
  IGetMapboxTilesetsQuery,
  IGetMapboxTilesetsQueryVariables
>
export const ListenTilesetsByProjectIdDocument = gql`
  subscription ListenTilesetsByProjectId($projectId: ObjectId!) {
    tileset(projectId: $projectId) {
      id
      item {
        ...MapboxTilesetFields
      }
    }
  }
  ${MapboxTilesetFieldsFragmentDoc}
`

/**
 * __useListenTilesetsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenTilesetsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenTilesetsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenTilesetsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenTilesetsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenTilesetsByProjectIdSubscription,
    IListenTilesetsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenTilesetsByProjectIdSubscription,
    IListenTilesetsByProjectIdSubscriptionVariables
  >(ListenTilesetsByProjectIdDocument, options)
}
export type ListenTilesetsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenTilesetsByProjectIdSubscription
>
export type ListenTilesetsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenTilesetsByProjectIdSubscription>
